import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const OpenLinkIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7731 9.22687L9 15M14.7731 9.22687C14.2678 8.72156 11.8846 9.21665 11.1649 9.22687M14.7731 9.22687C15.2784 9.73219 14.7834 12.1154 14.7731 12.8351"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);
export const OpenLinkIconSmall: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.84873 6.15125L6 10M9.84873 6.15125C9.51187 5.81437 7.92307 6.14443 7.44327 6.15125M9.84873 6.15125C10.1856 6.48813 9.8556 8.07693 9.84873 8.55673"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66797 8.0013C1.66797 5.01574 1.66797 3.52296 2.59546 2.59546C3.52296 1.66797 5.01574 1.66797 8.0013 1.66797C10.9868 1.66797 12.4796 1.66797 13.4072 2.59546C14.3346 3.52296 14.3346 5.01574 14.3346 8.0013C14.3346 10.9868 14.3346 12.4796 13.4072 13.4072C12.4796 14.3346 10.9868 14.3346 8.0013 14.3346C5.01574 14.3346 3.52296 14.3346 2.59546 13.4072C1.66797 12.4796 1.66797 10.9868 1.66797 8.0013Z"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);
